import { ff } from '@atlassian/jira-feature-flagging';
import {
	IssueTransitionLoadUFOExperience,
	issueTransittionModalLoadSubsequent,
	issueTransitionModalLoad,
	IssueTransitionUFOExperience,
} from '@atlassian/jira-issue-transition-analytics';
import { startUimTTI } from '@atlassian/jira-ui-modifications-analytics';
import traceUFOPress from '@atlassian/ufo-trace-press';

export const startIssueTransitionMetrics = (isSubsequentLoad: boolean) => {
	IssueTransitionLoadUFOExperience.start();
	if (ff('modernised-its-end-to-end-ufo-experience_m5e7f')) {
		IssueTransitionUFOExperience.start();
	}
	const issueTransitionModalLoadMetric = isSubsequentLoad
		? issueTransittionModalLoadSubsequent
		: issueTransitionModalLoad;
	if (isSubsequentLoad) {
		traceUFOPress('issue-transition.transition-modal-subsequent');
	} else {
		traceUFOPress('issue-transition.transition-modal');
	}

	issueTransitionModalLoadMetric.start();

	if (ff('ui-modifications-on-issue-transition-view_7z1g0')) {
		startUimTTI();
	}
};
